import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { WalletTransaction } from '../types';


interface UserTransactionsState {
  transactions: {
    [ userId: string ]: WalletTransaction[]
  };
  loading: boolean;
}

const initialState: UserTransactionsState = {
  transactions: {},
  loading: false,
}



const service = createSlice({
  name: 'userTransactions',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<{ isLoading: boolean, userId: string }>): UserTransactionsState {
      let newState = { ...state, loading: action.payload.isLoading };

      if (!action.payload.isLoading) {
        newState = {
          ...newState,
          transactions: {
            ...newState.transactions,
            [action.payload.userId]: []
          }
        }
      }

      return newState;
    },
    setTransactions(state, action: PayloadAction<{userId: string, transactions: WalletTransaction[]}>): UserTransactionsState {
      return { 
        ...state, 
        transactions: {
          ...state.transactions,
          [action.payload.userId]: action.payload.transactions,
        }, 
        loading: false,
      }
    },

  }
});


const loadTransactions = (userId: string): AppThunk => async (dispatch, getState) => {
  if (getState().userTransactions.transactions[userId]) {
    return;
  }
  
  dispatch(service.actions.setLoading({
    userId,
    isLoading: true,
  }));

  const query = firestore.collection('users')
    .doc(userId)
    .collection('wallet_transactions')
    .orderBy('createTime', 'desc')
    .limit(250);

  const result = await firestoreQuery<WalletTransaction>(query);

  dispatch(service.actions.setTransactions({
    userId,
    transactions: result.list,
  }));
}



export const actions = {
  loadTransactions,
}

export default service.reducer;